/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Addprospectstoyourlist5Inputs */

const en_coinvestments_addprospectstoyourlist5 = /** @type {(inputs: Coinvestments_Addprospectstoyourlist5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add prospects to your list`)
};

/**
* | output |
* | --- |
* | "Add prospects to your list" |
*
* @param {Coinvestments_Addprospectstoyourlist5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_addprospectstoyourlist5 = /** @type {((inputs?: Coinvestments_Addprospectstoyourlist5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Addprospectstoyourlist5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_addprospectstoyourlist5(inputs)
});
export { coinvestments_addprospectstoyourlist5 as "coInvestments_addProspectsToYourList" }